import { el } from "./dom";
import { createCornerOrnament } from "./CornerOrnament";

export function createCaseFrame(): HTMLElement {
  const frame = el("div", { class: "case-frame" });

  const cornerClasses = ["tl", "tr", "br", "bl"];
  for (const c of cornerClasses) {
    const wrap = el("div", { class: `case-frame__corner case-frame__corner--${c}` });
    wrap.appendChild(createCornerOrnament());
    frame.appendChild(wrap);
  }

  return frame;
}
